import { UserActivationStatus } from "@src/gql/graphql";
import { z } from "zod";

export const roleSchema = z.union([
	z.literal("Viewer"),
	z.literal("Editor"),
	z.literal("Owner"),
	z.literal("Waiting"),
	z.literal("Remove"),
]);

export const userSelected = z.object({
	name: z.string(),
	email: z.string(),
	avatarUrl: z.string(),
	activationStatus: z.nativeEnum(UserActivationStatus),
	permission: roleSchema,
});

export type Role = z.infer<typeof roleSchema>;

export const inviteFormSchema = z
	.object({
		selectedRole: roleSchema,
		emails: z.string().refine(
			(value) => {
				const emailList = value
					.split(",")
					.map((email) => email.trim())
					.filter((email) => email.length > 0);
				return emailList.every((email) =>
					/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
				);
			},
			{
				message: "Please enter valid comma-separated emails",
			},
		),
		users: z.array(userSelected),
	})
	.refine(
		(data) => {
			const newEmails = data.emails
				.split(",")
				.map((email) => email.trim())
				.filter((email) => email.length > 0);

			// Check for duplicates within the current input
			const uniqueNewEmails = new Set(newEmails);
			if (uniqueNewEmails.size !== newEmails.length) return false;

			// Check against existing emails in the list
			const existingEmails = new Set(data.users.map((item) => item.email));

			const validation = !newEmails.some((email) => existingEmails.has(email));
			return validation;
		},
		{
			message: "Duplicate email addresses are not allowed",
			path: ["emails"], // path of error
		},
	);
